exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-wrapper[data-v-b7ebaed4] {\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.modal-header h3[data-v-b7ebaed4] {\n  margin-top: 0;\n  color: #42b983;\n}\n.modal-body[data-v-b7ebaed4] {\n  margin: 20px 0;\n}\n.modal-default-button[data-v-b7ebaed4] {\n  float: right;\n}\n.backdrop[data-v-b7ebaed4] {\n  background: rgba(0, 0, 0, 0.6);\n}\n", ""]);

// exports
